import { transformOptions } from "../helperFunc";
import { baseAPI } from "./baseService";
import { CATALOGUES, MALSAPI } from "./serviceConstants";

export const catalogueAPI = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCatalogueDataById: builder.query({
      query: (arg) => {
        const { id, spw } = arg;
        if (spw)
          return {
            url: `${MALSAPI}/${CATALOGUES}/${id}/pointings`,
            params: { spw },
          };
        return { url: `${MALSAPI}/${CATALOGUES}/${id}/pointings` };
      },
      providesTags: ["catalogues"],
    }),
    getCatalogueReleaseStatus: builder.query({
      query: (id) => `${MALSAPI}/${CATALOGUES}/${id}/status`,
    }),
    publishCatalogue: builder.mutation({
      query: (arg) => {
        const { catalogueId, releaseInfo } = arg;
        return {
          url: `${MALSAPI}/${CATALOGUES}/${catalogueId}/release`,
          body: releaseInfo,
          method: "POST",
        };
      },
    }),
    signOffSearch: builder.mutation({
      query: (arg) => {
        const {release_name, catalogue_id} = arg;
        return {
          url: `${MALSAPI}/${CATALOGUES}/${release_name}/signoff`,
          params:{catalogue_id},
          method: "POST",
        };
      },
    }),
    getAllSpwsForACatalogue: builder.query({
      query: (arg) => {
        const { base_url, id, catalogue_id } = arg;
        if (base_url && id) return {
          url: `${MALSAPI}/${base_url}/${id}/spws`,
          params: {catalogue_id}
        };
        return { url: `` };
      },
      providesTags: ["spws"],
    }),
    editReleaseNotes: builder.mutation({
      query: (arg) => {
        return {
          url: `${MALSAPI}/${CATALOGUES}/${arg.releaseName}/release_note`,
          method: "POST",
          body: arg.releaseNote,
        };
      },
      invalidatesTags: ["releasenote"],
    }),
    getPointingNames: builder.query({
      query: (catId) => `${MALSAPI}/${CATALOGUES}/${catId}/pointing_names`,
      transformResponse: (response) => {
        return transformOptions(response.pointing_names);
      },
    }),
    getSPWSByPointingAndBand: builder.mutation({
      query: ({ catId, filterData }) => {
        return {
          url: `${MALSAPI}/${CATALOGUES}/${catId}/spws`,
          method: "POST",
          body: filterData,
        };
      },
      transformResponse: (response) => {
        return transformOptions(response.spws);
      },
    }),
    getSpectralSPWSByPointingAndBand: builder.mutation({
      query: ({ catId, filterData }) => {
        return {
          url: `${MALSAPI}/${CATALOGUES}/${catId}/spectral_spws`,
          method: "POST",
          body: filterData,
        };
      },
      transformResponse: (response) => {
        return transformOptions(response.spws);
      },
      providesTags:["spectralspws"]
    })
  }),
});

export const {
  useGetCatalogueDataByIdQuery,
  useGetCatalogueReleaseStatusQuery,
  usePublishCatalogueMutation,
  useSignOffSearchMutation,
  useGetAllSpwsForACatalogueQuery,
  useEditReleaseNotesMutation,
  useGetPointingNamesQuery,
  useGetSPWSByPointingAndBandMutation,
  useGetSpectralSPWSByPointingAndBandMutation
} = catalogueAPI;
